import { render, staticRenderFns } from "./HistorialDiasLibresModal.vue?vue&type=template&id=6ceb6c90"
import script from "./HistorialDiasLibresModal.vue?vue&type=script&lang=js"
export * from "./HistorialDiasLibresModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports